exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-box[data-v-19d0798e]{position:absolute;width:100%;left:0;bottom:0;top:0}.borderless[data-v-19d0798e]{border:none}span.enter-manual-class[data-v-19d0798e]{top:0;right:0;position:absolute;cursor:pointer;font-size:12px;line-height:21px;color:#007fe1;font-weight:300}.search-box input[data-v-19d0798e]{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-19d0798e&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AddressComponent.vue
// module id = 55
// module chunks = 0